function base64ToBlob(base64, mime) {
  const base64Data = base64.split(",")[1];
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mime });
}

function blobToFile(blob, fileName) {
  return new File([blob], fileName, { type: blob.type });
}

function fileToFileList(file) {
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  return dataTransfer.files;
}

export function base64ToFileList(base64String, fileName, mimeType) {
  const blob = base64ToBlob(base64String, mimeType);
  const file = blobToFile(blob, fileName);
  const fileList = fileToFileList(file);
  return fileList;
}
